import { render, staticRenderFns } from "./LetterList.vue?vue&type=template&id=4710fe1d&scoped=true&"
import script from "./LetterList.vue?vue&type=script&lang=js&"
export * from "./LetterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710fe1d",
  null
  
)

export default component.exports